import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  allURL = environment.apiURL+'country';

constructor(private httpClient: HttpClient) {}


  //Country
    getAllCountries(): Observable<any> {
       const url = this.allURL;
       return this.httpClient.get<any[]>(url);
     }


}